import React, { useState } from 'react';
import { Form, Input, Button, Layout, Typography, Row } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useHistory, Link } from 'react-router-dom';

import '../../styles/PageStyles/Login.less';
import { BaseAPI } from '../../utils/Api';
import Notification from '../../components/controls/Notification';

const { Content } = Layout;
const { Title } = Typography;

const Login = () => {
  const [form] = Form.useForm();
  const history = useHistory();

  const [loading, setLoading] = useState(false);

  const onFinish = (values) => {
    setLoading(true);
    BaseAPI.post('/auth/admin-login', { email: values.email, password: values.password })
      .then((res) => {
        console.log(res);
        localStorage.setItem('at', res.data.data.token);
        localStorage.setItem('ri', res.data.data.role_id);
        localStorage.setItem('i', res.data.data.id);
        history.push('/dashboard');
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          Notification(err?.response?.data?.message, 'error');
        } else {
          Notification('Something went wrong! Please try again later', 'error');
        }
      })
      .finally(() => setLoading(false));
  };

  return (
    <Layout className='login-layout'>
      <Content>
        <Form form={form} name='normal_login' className='login-form' onFinish={onFinish}>
          <Row justify='center'>
            <Title level={2} className='fg-primary'>
              RadMe Admin
            </Title>
          </Row>
          <Form.Item
            name='email'
            label='Email'
            labelCol={{ span: 24 }}
            rules={[
              {
                type: 'email',
                message: 'The input is not valid E-mail!',
              },
              {
                required: true,
                message: 'Please input your E-mail!',
              },
            ]}>
            <Input size='large' placeholder='Enter your email' />
          </Form.Item>
          <Form.Item
            name='password'
            label='Password'
            labelCol={{ span: 24 }}
            rules={[
              {
                required: true,
                message: 'Please input your Password!',
              },
            ]}>
            <Input.Password size='large' placeholder='Enter your password' />
          </Form.Item>
          <Form.Item>
            <Button block size='large' type='primary' htmlType='submit'>
              {loading && <LoadingOutlined />} Log In
            </Button>
          </Form.Item>
          <Form.Item>
            <Link to='/validate-email'>
              <Button type='text'>I forgot my password</Button>
            </Link>
          </Form.Item>
        </Form>
      </Content>
    </Layout>
  );
};

export default Login;
